import React from 'react';
import MediaLinks from './MediaLinks';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import { updateMediaLinks, updateContentMediaLinks } from './store/reducers/medialinks';
import scheduleDatasource from '@gameday/core/datasources/schedule';
import mediaLinksDataRequestAction from './store/actions/mediaLinksDataRequestAction';

initContainerData.register({
    datasources: {
        schedule: scheduleDatasource
    },
    reducers: {
        contentMediaLinks: updateContentMediaLinks,
        mediaLinks: updateMediaLinks
    }
});

const fetchData = () => {
    return mediaLinksDataRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const MediaDataContainer = () => {
    return (
        <MediaLinks />
    );
};

export default MediaDataContainer;
export { fetchData, routes };
